import {DocumentItem} from "./DocumentItem";

export default DocumentItem;